import Monthlyprofit from './Monthlyprofit.vue'//本月利润
import Consumablescost from './Consumablescost.vue'//物资成本
import Cost from './Cost.vue'//服务成本
import MonthlyIncome from './MonthlyIncome.vue'//当月收入
import Commissions from "./Commissions.vue"//销售佣金

let a = Object.assign({ Monthlyprofit, Consumablescost, Cost, MonthlyIncome, Commissions })
export default a
